import * as requests from '../api-request'

export const getByScriptUuid = async ({ scriptUuid, projectUuid }, signal) => {
  return requests.toJSON('GET', `box_office/${projectUuid}/${scriptUuid}`, {}, null, signal)
}

export const createBoxOfficeForecast = async ({ projectUuid, scriptUuid, ...data }) => {
  return requests.toJSON('POST', `box_office/${projectUuid}/${scriptUuid}`, { data })
}

export const cancelJob = async ({ projectUuid, scriptUuid, jobUuid }) => {
  return requests.toJSON('DELETE', `box_office/${projectUuid}/${scriptUuid}/${jobUuid}`, {}, null)
}
